import type { EditorAPI } from '#packages/editorAPI';
import type { CompRef } from 'types/documentServices';
import type { AppData, ComponentRef } from '@wix/platform-editor-sdk';
import type { WidgetSlot } from '@wix/editor-platform-host-integration/ui';
import { type PluginActionContext } from '@wix/editor-platform-host-integration-apis';

function getWidgetSlots(
  editorAPI: EditorAPI,
  _appData: AppData,
  _token: string,
  options: { widgetRef: ComponentRef },
): WidgetSlot[] {
  return editorAPI.platform.widgetPlugins.getWidgetSlots(options.widgetRef, {
    includePrivate: true,
  });
}

async function addWidgetPlugin(
  editorAPI: EditorAPI,
  _appData: AppData,
  _token: string,
  options: (
    | { slotCompRef: ComponentRef }
    | { hostCompRef: ComponentRef; slotId: string }
  ) & {
    widgetPluginPointer: {
      appDefinitionId: string;
      widgetId: string;
    };
  },
  context: PluginActionContext,
): Promise<CompRef> {
  const applicableOptions =
    'hostCompRef' in options ? options : options.slotCompRef;
  const slotInfo = await editorAPI.platform.widgetPlugins.getWidgetSlot(
    applicableOptions,
    { includePrivate: true },
  );
  if (slotInfo?.pluginInfo !== undefined) {
    await editorAPI.platform.widgetPlugins.uninstallWidgetPlugin(
      applicableOptions,
      context,
    );
  }
  return editorAPI.platform.widgetPlugins.installWidgetPlugin(
    applicableOptions,
    options.widgetPluginPointer,
    context,
  );
}

function removeWidgetPlugin(
  editorAPI: EditorAPI,
  _appData: AppData,
  _token: string,
  options:
    | { slotCompRef: ComponentRef }
    | { hostCompRef: ComponentRef; slotId: string },
  pluginActionContext: PluginActionContext,
): Promise<void> {
  const applicableOptions =
    'hostCompRef' in options ? options : options.slotCompRef;
  return editorAPI.platform.widgetPlugins.uninstallWidgetPlugin(
    applicableOptions,
    pluginActionContext,
  );
}

export const widgetPlugins = {
  getWidgetSlots,
  addWidgetPlugin,
  removeWidgetPlugin,
};
